import TableRegion from "../table/TableRegion";
import _ from "underscore";

export default class LockTableRegion extends TableRegion{
    constructor(type, lockTable, startRow, startCol, endRow, endCol){
        super(startRow, startCol, endRow, endCol);
        this.type = type;
        this.lockTable = lockTable;
    }

    createFromCells(type, lockTable, startCell, endCell)
    {
        return new LockTableRegion(
            type, lockTable,
            startCell.getRow().getRowIdx(), startCell.getColIdx(),
            endCell.getRow().getRowIdx(), endCell.getColIdx()
        );
    }

    getSelectedData()
    {
        return this.type.getSelectedData(this.lockTable, this);
    }

    canBeLocked()
    {
        return this.type.canBeLocked(this.lockTable, this);
    }

    canBeUnlocked()
    {
        return this.type.canBeUnlocked(this.lockTable, this);
    }

    getTopLeftVisibleCell()
    {
        return this.lockTable.getCell(this.rowMin, this.colMin);
    }

    getBottomRightVisibleCell()
    {
        let region = this;
        let row = this.lockTable.rows[region.rowMax];
        return row.accept({
                visitUserRow(cell) { return row.getCell(region.colMax); },
                visitDetailsRow(cell)
                {
                    let userRow = row.getParentRow();
                    if (userRow.isExpanded())
                        return row.getCell(region.colMax);
                    else
                        return userRow.getCell(region.colMax);
                },
                visitDatesRow: _.constant(null),
                visitRunnerRow: _.constant(null),
                visitInactiveRow: _.constant(null)
            }, null
        );
    }

    visitUserCells(visitor)
    {
        let userRows = this.lockTable.getUserRows(this.rowMin, this.rowMax);
        for (let i = 0; i < userRows.length; i++)
        {
            let currentRow = userRows[i];

            for (let colIdx = this.colMin; colIdx <= this.colMax; colIdx++)
            {
                visitor(currentRow.getCell(colIdx));
            }
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableRegion.js